module.exports = __webpack_public_path__ + "img/hontai_BlackMetallic.a7d544bc.png";